<template>
  <div class="kw_menu_lable">
    <div class="menu" :style="pageSetInfo.listStyleSet.listPageFieldStyleSet?pageSetInfo.listStyleSet.listPageFieldStyleSet.styleSetCode:''" kwName="listPageFieldStyleSet">
      <div v-for="(item,index) in treeArr" :key="index">
        <div class="menuFirst">
          <div class="menuTitle" :style="pageSetInfo.listStyleSet.listPageFieldNameStyleSet?pageSetInfo.listStyleSet.listPageFieldNameStyleSet.styleSetCode:''" kwName="listPageFieldNameStyleSet">{{item.NAME}}</div>
          <div class="menuTitleChild" :style="pageSetInfo.listStyleSet.listPageTabsBoxCommonStyleSet?pageSetInfo.listStyleSet.listPageTabsBoxCommonStyleSet.styleSetCode:''" kwName="listPageTabsBoxCommonStyleSet">
            <kw_tabs type="menu" v-model="twoCurrent" :multiple="dataMaxNum" :index="index" @change="twoChange" :tabsStyleSet="pageSetInfo.listStyleSet.listPageTabsCommonStyleSet?pageSetInfo.listStyleSet.listPageTabsCommonStyleSet.styleSetCode:''" kwName="listPageTabsCommonStyleSet">
              <kw_tab v-for="(twoInfo,twoIndex) in item.children" :key="twoIndex" type="menu" :index="twoInfo.list_index" :name="twoInfo.ID" :title="twoInfo.NAME" :tabDefaultStyle="pageSetInfo.listStyleSet.listPageTabDefaultCommonStyleSet?pageSetInfo.listStyleSet.listPageTabDefaultCommonStyleSet.styleSetCode:''" :tabCheckStyle="pageSetInfo.listStyleSet.listPageTabCheckCommonStyleSet?pageSetInfo.listStyleSet.listPageTabCheckCommonStyleSet.styleSetCode:''" kwName="listPageTabCommonStyleSet"></kw_tab>
            </kw_tabs>
          </div>
        </div>
      </div>
    </div>

    <button v-if="dataMaxNum!=1" @click="eventTrigger" type="button" class="menuBtn">确定</button>
  </div>
</template>

<script>

import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

// kw_tabs 标签组组件
import kw_tabs from '@/components/kw/kw_tabs.vue';
// kw_tab 标签组件
import kw_tab from '@/components/kw/kw_tab.vue';

export default {
  name: 'kw_menu_lable',
  props: {
    pageSetInfo: {
      type: Object,
      value: null
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList: {
      type: Array,
      value: null
    },
    //单一一条数据进行显示
    dataInfo: {
      type: Object,
      value: null
    },
    // 初始的默认选中值
    initCheckId: {
      type: String,
      value: null
    },
    //可以选中几个数据
    dataMaxNum: {
      type: Number,
      value: 1
    }
  },
  data() {
    return {
      treeArr: [],
      oneCurrent: 0,
      oneIndex: 0,
      twoCurrent: 0,
      twoIndex: [],
      checkDataInfo: []
    };
  },
  created() {
    var that = this;
    // console.log("that.data.dataList=====================", that.data.dataList);
    var treeArr = pageUtils.buildTree(that.dataList);
    // console.log("treeArr=====================", treeArr);
    var initCheckId = this.initCheckId;
    // console.log("initCheckId=====================", initCheckId);
    var oneCurrent = 0;
    var twoCurrent = "";
    var checkDataInfo = [];
    var twoIndex = [];
    if (initCheckId != null && initCheckId != undefined && initCheckId != "" && that.dataList.length > 0) {
      var initCheckIdArr = initCheckId.split(",");
      for (var i = 0; i < initCheckIdArr.length; i++) {
        var nowCheckEle = that.dataList[i];
        twoCurrent += (twoCurrent != "" ? "," : "") + nowCheckEle.ID;
        oneCurrent = nowCheckEle.PID;
        checkDataInfo.push(nowCheckEle);
        twoIndex.push(nowCheckEle.list_index);
      }
    } else {
      if (treeArr.length > 0) {
        oneCurrent = treeArr[0].ID;
      }
    }
    that.oneCurrent = oneCurrent;
    that.twoCurrent = twoCurrent;
    that.checkDataInfo = checkDataInfo;
    that.twoIndex = twoIndex;
    that.treeArr = treeArr;
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    kw_tabs,
    kw_tab
  },
  methods: {
    /**
     * 列表数据点击时 进行跳转
     */
    listDataClick(dataInfo) {
      pageUtils.listDataClick(this, dataInfo);
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo) {
      pageUtils.dataButtonClick(this,detail,dataInfo);
    },
    oneChange({ detail }) {
      this.setData({
        oneCurrent: detail.key,
        oneIndex: detail.index,
        twoCurrent: 0,
        twoIndex: []
      });
    },
    twoChange(detail,parIndex) {
      console.log("detail===========================", detail, parIndex);
      var nowOneDataChild = this.dataList;
      var twoIndex = [];
      // 添加index之前 先进行把当前子tab的选中取消掉
      this.twoIndex.forEach(itemIndex => {
        var flag = true;
        this.treeArr[parIndex].children.forEach(item => {
          if(itemIndex == item.list_index) {
            flag = false;
          }
        })
        if(flag) {
          twoIndex.push(itemIndex);
        }
      })
      
      if (this.dataMaxNum == 1) {
        //返回上一个页面 并切换数据ID 进行查看页面的数据切换
        twoIndex = [detail.index];
      } else {
        detail.forEach(item => {
          twoIndex.push(item.index);
        })
      }
      // console.log("twoCurrent============", twoCurrent);
      
      this.twoIndex = twoIndex;

      var checkDataInfo = [];
      
      // console.log("twoCurrent============", this.data.oneIndex, nowOneDataChild);
      var twoCurrent = "";
      twoIndex.forEach(item => {
        if (twoCurrent != "") {
            twoCurrent += ",";
          }
        twoCurrent += nowOneDataChild[item].ID;
        checkDataInfo.push(nowOneDataChild[item]);
      })
      // console.log("checkDataInfo==================", checkDataInfo);
      this.twoCurrent = twoCurrent;
      this.checkDataInfo = checkDataInfo;
      if (this.dataMaxNum == 1) {
        this.eventTrigger();
      }
    },
    eventTrigger: function () {
//      console.log("点击事件1111");
      var twoCurrent = this.twoCurrent; //通过这个传递数据
      var checkDataInfo = this.checkDataInfo;
      var myEventDetail = {
        val: twoCurrent,
        checkDataInfo: checkDataInfo
      } // detail对象，提供给事件监听函数
      this.$emit('callbackevent', myEventDetail);//myevent自定义名称事件，父组件中使用
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.menu{padding: 10px}
.menuTitle{display: inline-block;font-size: 16px;color: #3F3F3F;font-weight: bold;width: 70px;height: 32px;line-height: 32px;}
.menuFirst{display: flex;justify-content: flex-start;margin: 15px 0}
.menuTitleChild{width: 300px}
.menuBtn{width: 100%;border: none;background: #DEDEDE;padding: 7px 0;font-size: 16px}
</style>
